module.exports = __webpack_public_path__ + "media/theme/zigzag--sp--black_01-b4c76563.png";